import React, { Component } from 'react'
import { Button, Icon } from 'antd';
import contact from '../../assets/images/button-bg/bg-contact-us.png'
import download from '../../assets/images/button-bg/bg-download.png'
import commonProblem from '../../assets/images/button-bg/bg-common-problem.png'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { exeDownUrl, introDownUrl } from '../../utils/config'

const handleDown = () => {
    let url = window.location.host;
    if (introDownUrl[url]) {
        window.location.href = introDownUrl[url]
    } else {
        window.location.href = 'https://es-repo.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.docx'// 'http://es-update.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.docx'
    }
};
const TYPE = {
    CONTACT: '1',//联系
    COMMON_PROBLEM: '2',//常见问题
    INTRO: '3'
}
class SideBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [
                {
                    url: contact,//图片路径
                    text: '',//標題
                    buttonType: '',//按鈕類型
                    buttonText: 'header004',//按鈕文字
                    type: TYPE.CONTACT,//父組件給子組件傳值
                    default: false,//显示还是隐藏
                }, {
                    url: commonProblem,
                    text: '',
                    buttonType: '',
                    buttonText: 'header002',
                    type: TYPE.COMMON_PROBLEM,
                    default: false
                },
                {
                    url: commonProblem,
                    text: 'own_application',
                    buttonType: 'download',
                    buttonText: 'button_download',
                    type: TYPE.INTRO,
                    default: false
                }
            ]
        };
        this.handleContact = this.handleContact.bind(this);
        this.handleCommonProblem = this.handleCommonProblem.bind(this)
    }
    handleContact() {
        this.props.history.push({ pathname: "/contactUs" })
    }
    handleCommonProblem() {
        this.props.history.push({ pathname: '/commonProblem' })
    }
    handleClick(val) {
        switch (val) {
            case TYPE.CONTACT:
                return this.handleContact;
                break;
            case TYPE.COMMON_PROBLEM:
                return this.handleCommonProblem;
                break;
            case TYPE.INTRO:
                return this.downloadExe;
                break
        }
    }
    downloadExe() {
        let url = window.location.host;
        if (exeDownUrl[url]) {
            window.location.href = exeDownUrl[url]
        }
    }
    componentDidMount() {
        let list = this.state.list.map(item => {
            item.default = false
            if (item.type === this.props.type) {
                item.default = true
            }
            return item
        })
        this.setState({
            list: list
        })
    }
    render() {
        const { t } = this.props
        return (
            <div className="side-box">
                <div className="side-box-item pr" style={{ background: 'url(' + download + ') no-repeat' }}>
                    <div style={{ zIndex: '2', textAlign: 'center' }}>
                        <h5>{t('cmp_handbook')}</h5>
                        <Button type="" className="side-box-item_button" style={{ color: '#25ae3c', background: '#fafafa', opacity: '0.7' }} onClick={handleDown}>
                            <Icon type="download" />
                            {t('button_download')}
                        </Button>
                    </div>
                    {/* <span className="bg-opacity pa" style={{ bottom: "51" }}></span> */}
                </div>
                {
                    this.state.list.map((item) =>
                        item.default && <div className="side-box-item pr" key={Math.random() * 100} style={{ background: 'url(' + item.url + ') no-repeat' }} >
                            <div style={{ zIndex: '2', textAlign: 'center' }}>
                                {item.text && <h5>{t(item.text)}</h5>}
                                <Button type="" className="side-box-item_button"
                                    onClick={this.handleClick(this.props.type)}
                                    style={{ color: item.text ? "#25ae3c" : '#2d2d2d', background: '#fafafa', opacity: '0.7' }}
                                >
                                    {item.buttonType && item.buttonType ? <Icon type="download" /> : ''}
                                    {t(item.buttonText)}
                                </Button>
                            </div>
                            {/* <span className="bg-opacity pa" style={{ bottom: (item.text ? "51" : "0") }}></span> */}
                        </div>
                    )
                }
            </div>
        )
    }
}
export default withTranslation()(withRouter(SideBox))